__webpack_require__.p = "/MinerGame/";